function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M373.411,178.463c-.157,56.383-45.983,98.838-102.366,98.681S169.073,234.279,169.23,177.9s45.98-97.8,102.363-97.64S373.569,122.08,373.411,178.463Z",
  transform: "translate(-68.423 -55.246)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M367.233,216.031,239.32,88.118c-40.608,12.324-69.966,47.847-70.092,92.957-.157,56.383,45.432,99.092,101.816,99.25C315.214,280.447,352.9,254.418,367.233,216.031Z",
  transform: "translate(-68.422 -58.425)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M237.714,38.271c-17.284.178-62.434,6.174-63.929,63.78a6.863,6.863,0,0,0,7.036,7.036c57.606-1.5,63.6-46.645,63.78-63.929A6.824,6.824,0,0,0,237.714,38.271Z",
  transform: "translate(-70.263 -38.27)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M244.014,41.677l-66.806,66.806a6.834,6.834,0,0,0,5,1.98c57.606-1.5,63.6-46.645,63.78-63.929A6.792,6.792,0,0,0,244.014,41.677Z",
  transform: "translate(-71.648 -39.648)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M153.464,124.61c-2.08.175-4.225.27-6.407.27-1.539,0-3.05-.043-4.539-.139a152.764,152.764,0,0,0-4.83-36.519,100,100,0,0,0-9-22.692c-6.8-12.222-13.681-17.286-13.754-17.337a5.472,5.472,0,0,1,6.326-8.931c1,.7,18.971,13.776,27.624,48.4A162.31,162.31,0,0,1,153.464,124.61Z",
  transform: "translate(-45.552 -38.27)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M204.182,241.409c-.157,56.383-45.983,98.838-102.366,98.681S-.157,297.224,0,240.841s45.98-97.8,102.363-97.64S204.339,185.026,204.182,241.409Z",
  transform: "translate(0 -80.696)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M201.169,247.567c-.142,51.206-41.76,89.762-92.965,89.619S15.6,298.256,15.739,247.052,57.5,158.236,108.7,158.379,201.311,196.362,201.169,247.567Z",
  transform: "translate(-6.363 -86.832)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_24",
  "data-name": "Group 24",
  transform: "translate(18.437 80.127)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M55.09,362.275a10.556,10.556,0,0,1-8.4-4.136A80.379,80.379,0,0,1,31.2,322.48,10.706,10.706,0,0,1,41.8,310.046l59.919.167a4.206,4.206,0,0,1,2.954,7.188L62.7,359.149a10.676,10.676,0,0,1-7.606,3.126Z",
  transform: "translate(-30.992 -228.281)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M130.306,244.884a4.167,4.167,0,0,1-2.959-1.243L86.116,202.179a10.7,10.7,0,0,1-3.062-8.746,10.573,10.573,0,0,1,4.814-7.79A86.178,86.178,0,0,1,122.405,172.9a11.081,11.081,0,0,1,1.586-.112,10.735,10.735,0,0,1,10.7,10.742l-.159,57.16a4.15,4.15,0,0,1-1.333,3.064,4.227,4.227,0,0,1-2.9,1.134Z",
  transform: "translate(-51.991 -172.784)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_120",
  "data-name": "Path 120",
  d: "M41.644,270.644A10.71,10.71,0,0,1,31.087,258.25,79.021,79.021,0,0,1,46.7,222.335a10.555,10.555,0,0,1,8.416-4.08,10.674,10.674,0,0,1,7.589,3.168l41.981,42.215a4.206,4.206,0,0,1-2.994,7.172Z",
  transform: "translate(-30.951 -191.169)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  d: "M177.569,244.957a4.219,4.219,0,0,1-4.206-4.221l.159-57.16a10.741,10.741,0,0,1,12.349-10.561,86.185,86.185,0,0,1,34.465,12.938,10.571,10.571,0,0,1,4.77,7.817A10.7,10.7,0,0,1,222,202.5l-41.461,41.231a4.156,4.156,0,0,1-2.965,1.228Z",
  transform: "translate(-88.531 -172.828)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M123.435,395.1a10.985,10.985,0,0,1-1.622-.126A85.488,85.488,0,0,1,87.5,381.865a10.586,10.586,0,0,1-4.724-7.819,10.7,10.7,0,0,1,3.113-8.695l41.3-41.066a4.165,4.165,0,0,1,2.966-1.227,4.218,4.218,0,0,1,4.206,4.221l-.159,57.137A10.723,10.723,0,0,1,123.436,395.1S123.436,395.1,123.435,395.1Z",
  transform: "translate(-51.881 -233.543)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M183.676,395.185a10.733,10.733,0,0,1-10.7-10.743l.159-57.137a4.218,4.218,0,0,1,4.229-4.2,4.167,4.167,0,0,1,2.959,1.243l41.066,41.3a10.7,10.7,0,0,1,3.065,8.712,10.586,10.586,0,0,1-4.767,7.793A85.5,85.5,0,0,1,185.3,395.067a10.913,10.913,0,0,1-1.623.117Z",
  transform: "translate(-88.375 -233.562)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  d: "M190.224,271.108a4.206,4.206,0,0,1-2.954-7.188l42.215-41.981a10.676,10.676,0,0,1,7.606-3.126,10.554,10.554,0,0,1,8.393,4.128,79.006,79.006,0,0,1,15.41,36,10.71,10.71,0,0,1-10.625,12.334Z",
  transform: "translate(-75.214 -111.266)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_125",
  "data-name": "Path 125",
  d: "M236.54,362.767a10.674,10.674,0,0,1-7.589-3.168L187.2,317.618a4.206,4.206,0,0,1,2.994-7.172l59.919.167A10.7,10.7,0,0,1,260.654,323.1a80.38,80.38,0,0,1-15.691,35.572,10.554,10.554,0,0,1-8.423,4.09Z",
  transform: "translate(-75.194 -148.316)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_126",
  "data-name": "Path 126",
  d: "M190.383,249.811a3.605,3.605,0,0,0-1.354-1c-2.925-1.207-6.958,1.837-9.007,6.8-1.8,4.372-1.468,8.77.637,10.583L200.91,286.56a3.61,3.61,0,0,0,1.354,1c2.925,1.207,6.958-1.837,9.007-6.8,1.8-4.372,1.468-8.77-.637-10.583Z",
  transform: "translate(-72.313 -123.289)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M129.166,317.841c-1.806-2.119-6.219-2.456-10.6-.635-4.959,2.061-7.994,6.1-6.779,9.022a3.609,3.609,0,0,0,.98,1.332l20.251,20.364c1.806,2.119,6.219,2.457,10.6.636,4.959-2.061,7.994-6.1,6.779-9.022a3.6,3.6,0,0,0-.98-1.332Z",
  transform: "translate(-45.088 -150.571)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_128",
  "data-name": "Path 128",
  d: "M153.731,338.582a3.605,3.605,0,0,0-1.354-1c-2.925-1.207-6.958,1.837-9.007,6.8-1.8,4.372-1.468,8.771.637,10.583l20.251,20.364a3.61,3.61,0,0,0,1.354,1c2.925,1.207,6.958-1.837,9.007-6.8,1.8-4.372,1.468-8.77-.637-10.583Z",
  transform: "translate(-57.494 -159.181)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M216.622,320.391a14.563,14.563,0,0,0-4.945-3.287c-4.964-2.049-9.966-1.34-11.173,1.585-.768,1.86.188,4.166,2.259,6.127l20.251,20.364a14.56,14.56,0,0,0,4.946,3.287c4.964,2.049,9.966,1.34,11.173-1.585.768-1.86-.188-4.166-2.259-6.127Z",
  transform: "translate(-80.96 -150.534)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M127.851,283.739a14.56,14.56,0,0,0-4.946-3.287c-4.964-2.049-9.966-1.34-11.174,1.585-.768,1.86.188,4.166,2.26,6.127,0,0,20.109,20.23,20.251,20.364a14.561,14.561,0,0,0,4.946,3.287c4.964,2.049,9.966,1.34,11.173-1.585.768-1.86-.188-4.166-2.26-6.127Z",
  transform: "translate(-45.068 -135.715)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M217.853,280.988c-1.806-2.119-6.219-2.456-10.6-.635-4.959,2.061-7.994,6.1-6.779,9.022a3.609,3.609,0,0,0,.98,1.332L221.7,311.071c1.806,2.119,6.219,2.457,10.6.635,4.959-2.061,7.994-6.1,6.779-9.022a3.609,3.609,0,0,0-.98-1.332Z",
  transform: "translate(-80.946 -135.67)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_132",
  "data-name": "Path 132",
  d: "M187.858,339.846c-1.975-2.1-4.3-3.07-6.174-2.292-2.922,1.214-3.621,6.218-1.56,11.177a14.6,14.6,0,0,0,3.252,4.9l20.251,20.364c1.975,2.1,4.3,3.07,6.175,2.292,2.922-1.214,3.621-6.218,1.56-11.177a14.6,14.6,0,0,0-3.252-4.9Z",
  transform: "translate(-72.349 -159.168)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M151,251.16c-1.975-2.1-4.3-3.07-6.175-2.292-2.922,1.214-3.621,6.218-1.56,11.177a14.582,14.582,0,0,0,3.252,4.9L166.773,285.3c1.975,2.1,4.3,3.07,6.174,2.292,2.922-1.214,3.621-6.218,1.56-11.177a14.593,14.593,0,0,0-3.252-4.895Z",
  transform: "translate(-57.448 -123.311)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M190.614,259.987c-2.049,4.964-6.082,8.008-9.007,6.8s-3.635-6.211-1.585-11.173,6.082-8.008,9.007-6.8S192.664,255.024,190.614,259.987Z",
  transform: "translate(-72.313 -123.29)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M153.962,348.757c-2.049,4.964-6.082,8.008-9.007,6.8s-3.635-6.211-1.585-11.174,6.082-8.008,9.007-6.8S156.012,343.794,153.962,348.757Z",
  transform: "translate(-57.493 -159.181)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25",
  transform: "translate(66.398 143.566)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M207.3,327.7c-4.964-2.049-8.008-6.082-6.8-9.007s6.211-3.635,11.173-1.585,8.008,6.082,6.8,9.007S212.265,329.747,207.3,327.7Z",
  transform: "translate(-147.357 -294.101)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M118.531,291.045c-4.964-2.049-8.008-6.082-6.8-9.007s6.211-3.635,11.173-1.585,8.008,6.082,6.8,9.007S123.494,293.094,118.531,291.045Z",
  transform: "translate(-111.465 -279.282)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M211.649,290.935c-4.959,2.061-9.963,1.362-11.177-1.56s1.821-6.962,6.779-9.022,9.963-1.362,11.177,1.56S216.608,288.874,211.649,290.935Z",
  transform: "translate(-80.947 -135.67)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M122.961,327.788c-4.959,2.061-9.963,1.362-11.177-1.56s1.821-6.962,6.779-9.022,9.963-1.362,11.177,1.56S127.92,325.727,122.961,327.788Z",
  transform: "translate(-45.088 -150.57)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "Group_26",
  "data-name": "Group 26",
  transform: "translate(84.638 125.29)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M180.122,348.732c-2.061-4.959-1.362-9.963,1.56-11.177s6.962,1.821,9.022,6.779,1.362,9.963-1.56,11.177S182.183,353.691,180.122,348.732Z",
  transform: "translate(-156.986 -284.458)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M143.269,260.044c-2.061-4.959-1.362-9.963,1.56-11.177s6.962,1.821,9.022,6.779,1.362,9.963-1.56,11.177S145.33,265,143.269,260.044Z",
  transform: "translate(-142.085 -248.6)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M166.769,143.2q-3.77-.011-7.474.228l108.7,108.7a102.027,102.027,0,0,0,.593-10.719,98.827,98.827,0,0,0-3.616-26.974l-66.55-66.55A110.058,110.058,0,0,0,166.769,143.2Z",
  transform: "translate(-64.406 -80.695)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(237.708 51.755)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_51",
  "data-name": "Ellipse 51",
  cx: 6.072,
  cy: 6.072,
  rx: 6.072,
  ry: 6.072,
  transform: "translate(24.461 57.734)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_52",
  "data-name": "Ellipse 52",
  cx: 3.036,
  cy: 3.036,
  r: 3.036,
  transform: "translate(16.17 60.77)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_53",
  "data-name": "Ellipse 53",
  cx: 3.036,
  cy: 3.036,
  r: 3.036,
  transform: "translate(19.687 8.438)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_54",
  "data-name": "Ellipse 54",
  cx: 3.036,
  cy: 3.036,
  r: 3.036,
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_55",
  "data-name": "Ellipse 55",
  cx: 3.036,
  cy: 3.036,
  r: 3.036,
  transform: "translate(5 16.248)",
  fill: "rgba(147,147,147,0.69)"
}));

function SvgMausambi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mausambi",
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.989,
    height: 259.395,
    viewBox: "0 0 304.989 259.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMausambi);
export default __webpack_public_path__ + "static/media/mausambi.0ef56bce.svg";
export { ForwardRef as ReactComponent };